import { render, staticRenderFns } from "./imagenesPopUp.vue?vue&type=template&id=621d72b2&scoped=true&"
import script from "./imagenesPopUp.vue?vue&type=script&lang=js&"
export * from "./imagenesPopUp.vue?vue&type=script&lang=js&"
import style0 from "./imagenesPopUp.vue?vue&type=style&index=0&id=621d72b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d72b2",
  null
  
)

export default component.exports